import { type AlertProps } from 'antd';

import { StyledAlert } from './Alert.style';

interface Props extends AlertProps {}

export function Alert({ type, ...rest }: Props) {
  return <StyledAlert {...rest} type={type} $type={type} />;
}

export function SuccessAlert(props: Props) {
  return <Alert type="success" {...props} />;
}

export function InfoAlert(props: Props) {
  return <Alert type="info" {...props} />;
}

export function WarningAlert(props: Props) {
  return <Alert type="warning" {...props} />;
}

export function ErrorAlert(props: Props) {
  return <Alert type="error" {...props} />;
}
